import React from 'react';
import { Spin } from 'antd';

interface FormContainerProps {
  title: string;
  children: React.ReactNode;
  loading?: boolean;
}

const FormContainer: React.FC<FormContainerProps> = ({
  title,
  children,
  loading = false,
}) => {
  return (
    <Spin spinning={loading}>
      <div className="py-6">
        <h1 className="text-2xl font-semibold mb-6">{title}</h1>
        {children}
      </div>
    </Spin>
  );
};

export default FormContainer;
